import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.match";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { questionnaireResultStatistics, questionnaireResultUserList, questionnaireResultExport } from "@/api/gmtool/packageCode";
import { gmTool } from "@/mixins/index";
import questionDetail from "./questionDetail.vue";
import * as XLSX from 'xlsx';
export default {
  mixins: [gmTool],
  components: {
    questionDetail: questionDetail
  },
  data: function data() {
    return {
      dialogShow: false,
      activeIndex: '0',
      questionResult: [],
      tableData: [],
      total: 0,
      questionnaireId: '',
      paramsData: {
        page: 1,
        server_id: '',
        start_time: '',
        end_time: '',
        user_id: ''
      },
      customColors: [{
        color: '#f56c6c',
        percentage: 20
      }, {
        color: '#e6a23c',
        percentage: 40
      }, {
        color: '#5cb87a',
        percentage: 60
      }, {
        color: '#1989fa',
        percentage: 80
      }, {
        color: '#6f7ad3',
        percentage: 100
      }],
      exportQuestionData: []
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      this.activeIndex = 0, this.questionnaireId = data.id;
      this.getResult(data.id);
      this.dialogShow = true;
    },
    Renewal: function Renewal() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.paramsData.server_id = '';
                _context.next = 3;
                return _this.getserverList();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    modelChange: function modelChange(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.activeIndex = e;

                if (!(e == 1)) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 4;
                return _this2.Renewal();

              case 4:
                _this2.getList();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getResult: function getResult(id) {
      var _this3 = this;

      questionnaireResultStatistics({
        questionnaire_id: id
      }).then(function (res) {
        if (res.status == 200) {
          _this3.questionResult = res.data.statistics;
        }
      });
    },
    getList: function getList(e) {
      var _this4 = this;

      this.paramsData.page = e;
      this.reqLoading = true;
      questionnaireResultUserList(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        questionnaire_id: this.questionnaireId,
        game_id: this.rawData.game_id
      })).then(function (res) {
        if (res.status == 200) {
          _this4.tableData = res.data;

          _this4.tableData.forEach(function (item) {
            var foundData = _this4.serverLists.find(function (b) {
              return b.serverID == item.server_id;
            });

            item.server_name = foundData ? foundData.serverName : '';
          });

          _this4.total = res.total;
        }
      }).finally(function () {
        _this4.reqLoading = false;
      });
    },
    hiad: function hiad() {
      this.dialogShow = false;
    },
    exportData: function exportData() {
      var _this5 = this;

      // 1. 触发请求获取数据
      questionnaireResultExport(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        questionnaire_id: this.questionnaireId
      })).then(function (res) {
        if (res.code == 0) {
          var serverPayload = res.data;
          var wb = XLSX.utils.book_new();

          if (serverPayload.form1) {
            var f1 = serverPayload.form1;
            var sheetData1 = []; // 压入表头

            sheetData1.push(f1.headers);
            f1.data.forEach(function (row) {
              // 前三列是固定的基础信息
              var rowData = [row.question_id, row.question, row.participant_count];
              var optionCount = Math.floor((f1.headers.length - 3) / 3);

              for (var i = 1; i <= optionCount; i++) {
                rowData.push(row["option_".concat(i, "_desc")] !== undefined ? row["option_".concat(i, "_desc")] : '');
                rowData.push(row["option_".concat(i, "_count")] !== undefined ? row["option_".concat(i, "_count")] : 0);
                rowData.push(row["option_".concat(i, "_percentage")] !== undefined ? row["option_".concat(i, "_percentage")] + '%' : '0%');
              }

              sheetData1.push(rowData);
            });
            var ws1 = XLSX.utils.aoa_to_sheet(sheetData1);
            XLSX.utils.book_append_sheet(wb, ws1, f1.title || _this5.$t('choiceQuestionStatistics'));
          } // --- 处理第二个工作表：文本题明细 (form2) ---


          if (serverPayload.form2) {
            var f2 = serverPayload.form2;
            var sheetData2 = [];
            sheetData2.push(f2.headers);
            f2.data.forEach(function (row) {
              // 前两列是固定的基础信息
              var rowData = [row.user_id, row.role_id];

              for (var i = 2; i < f2.headers.length; i++) {
                var headerText = f2.headers[i] || '';
                var match = headerText.match(/^(\d+)-/);

                if (match) {
                  var qNum = match[1];
                  rowData.push(row["question_".concat(qNum)] !== undefined ? row["question_".concat(qNum)] : '');
                } else {
                  // 容错处理：万一后端返回的表头没带 "3-" 这种前缀，则根据索引兜底推算
                  rowData.push(row["question_".concat(i + 1)] !== undefined ? row["question_".concat(i + 1)] : '');
                }
              }

              sheetData2.push(rowData);
            });
            var ws2 = XLSX.utils.aoa_to_sheet(sheetData2);
            XLSX.utils.book_append_sheet(wb, ws2, f2.title || _this5.$t('fillBlankAnswerSheet'));
          }

          if (serverPayload.form3) {
            var f3 = serverPayload.form3;
            var sheetData3 = [];
            sheetData3.push(f3.headers); // 压入表头

            f3.data.forEach(function (row) {
              // 前一列是固定的基础信息：角色ID
              var rowData = [row.role_id]; // 从第 2 列（索引为 1）开始遍历题目表头

              for (var i = 1; i < f3.headers.length; i++) {
                var headerText = f3.headers[i] || '';
                var match = headerText.match(/^(\d+)-/);

                if (match) {
                  var qNum = match[1];
                  rowData.push(row["question_".concat(qNum)] !== undefined ? row["question_".concat(qNum)] : '');
                } else {
                  // 容错处理：若无前缀，通过索引兜底
                  rowData.push(row["question_".concat(i)] !== undefined ? row["question_".concat(i)] : '');
                }
              }

              sheetData3.push(rowData);
            });
            var ws3 = XLSX.utils.aoa_to_sheet(sheetData3);
            XLSX.utils.book_append_sheet(wb, ws3, f3.title || _this5.$t('roleAnswerDetailSheet'));
          }

          var fileName = "".concat(_this5.$t('questionnaireResultExportFileName'), ".xlsx");
          XLSX.writeFile(wb, fileName);

          _this5.$message.success(_this5.$t('exportSuccessExclamation'));
        } else {
          _this5.$message.error(res.message || _this5.$t('exportFailedNoValidData'));
        }
      }).catch(function (err) {
        console.error("导出异常:", err);

        _this5.$message.error(_this5.$t('exportApiRequestFailed'));
      });
    },
    clearData: function clearData() {}
  }
};